/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CouponCodeGridItemViewModel } from "../types/CouponCodeGridItemViewModel.ts";

export const couponCodeGridItemViewModelSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe("ID do registro de código ou da utilização. Opcional."),
  ),
  code: z.string().describe("Código do cupom.").nullish(),
  available: z.optional(
    z
      .boolean()
      .describe(
        "Situação do slot do código. Atenção: fiel ao legado, o significado se inverte por tipo — no cupom manual `true` indica slot livre; no automático `true` indica código já utilizado.",
      ),
  ),
  classStudent: z
    .string()
    .describe(
      "Descrição da turma em que o código foi utilizado. Nulo quando o slot está livre. Opcional.",
    )
    .nullish(),
  date: z
    .string()
    .datetime()
    .describe(
      "Data em que o código foi utilizado. Nulo quando o slot está livre. Opcional.",
    )
    .nullish(),
  person: z
    .string()
    .describe(
      "Nome da pessoa que utilizou o código. Nulo quando o slot está livre. Opcional.",
    )
    .nullish(),
  enrollmentStatus: z
    .string()
    .describe(
      "Situação da matrícula em que o código foi utilizado (descrição já resolvida). Opcional.",
    )
    .nullish(),
  value: z
    .number()
    .describe(
      "Valor de desconto aplicado na utilização (fixo, ou calculado pelo percentual sobre o valor do curso; 0 quando cortesia). Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<CouponCodeGridItemViewModel>;
